import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { useSite } from "../context/SiteContext";

export default function FAQ() {
  const { content } = useSite();
  const faqs = content.faqs || [];
  return (
    <section id="faq" className="section" data-testid="faq-section">
      <div className="container-x px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="eyebrow mb-4">FAQ & Etiquette</div>
          <h2 className="font-display text-4xl md:text-6xl text-gold leading-tight mb-4">
            Everything you were going to ask.
          </h2>
          <p className="text-ivory-dim mb-10">
            If it's not here, just message me on WhatsApp — I don't judge, I
            just answer.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          className="max-w-3xl divide-y divide-[rgba(201,169,97,0.14)] border-t border-b border-[rgba(201,169,97,0.14)]"
          data-testid="faq-accordion"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-none"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-ivory hover:text-gold py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-ivory-dim leading-relaxed text-base pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
